import React from 'react';
import Label from 'components/_utility/Label';
import { getImageBaseUrl } from 'helpers/request';
import fetchGoal from 'helpers/goals';
import { getGoalId } from 'src/redux/app/selectors';
import { useSelector } from 'react-redux';

import {
  Wrap,
  ImageWrap,
  Image,
  Content,
  Name,
  Price,
  Description,
  Actions,
  Action,
  ActionLink,
  Divider,
  MainContent,
  AdditionalContent,
  DetailedDescription,
} from './BikeCard.styled';

export const BikeCard = ({
  className,
  bike: { id, name, thumbnail, priceLocalised, pricePrefixText, description, detailDescription, url },
  family = false,
  isListingsPage = false,
  listView = false,
  ...props
}) => {
  return (
    <Wrap className={className} isListingsPage={isListingsPage} listView={listView} {...props}>
      <MainContent listView={listView}>
        <ImageWrap to={family ? `/bikes/family/${id}` : `/bike/${id}/configure`} listView={listView}>
          {thumbnail ? <Image src={getImageBaseUrl() + thumbnail.src} alt={thumbnail.alt} /> : null}
        </ImageWrap>
        <Content isListingsPage={isListingsPage} listView={listView}>
          <Name dangerouslySetInnerHTML={{ __html: name }} listView={listView} />
          <Price listView={listView}>
            {pricePrefixText || <Label name="fromLabel" />} {priceLocalised}
          </Price>
          <Description dangerouslySetInnerHTML={{ __html: description }} isListingsPage={isListingsPage} />
        </Content>
      </MainContent>
      <AdditionalContent listView={listView}>
        <DetailedDescription
          listView={listView}
          dangerouslySetInnerHTML={{ __html: detailDescription }}
        ></DetailedDescription>
        <Actions>
          <Action onClick to={family ? `/bikes/family/${id}` : `/bike/${id}/configure`} primary>
            <Label name="configureLabel" />
          </Action>
          <Divider />
          <ActionLink href={url}>
            <Label name="viewDetailsLabel" />
          </ActionLink>
        </Actions>
      </AdditionalContent>
    </Wrap>
  );
};

export default BikeCard;
